<app-topheader></app-topheader>
<div class="obscrollingcontainer ">
    <!-- <div class="obscrollingcontainer " [ngClass]="{nonIOS:nonIOSdevice}"></div> -->
    <!-- <div class="obscrollingcontainer "> -->

    <div class="container">
        <app-fancy-page-title topTitle="YOUR NEXT ADVENTURE" subTitle=""></app-fancy-page-title>


        <app-longgoldbar></app-longgoldbar>


        <app-itinerary-explorer></app-itinerary-explorer>
    </div>
</div>
<app-bottommenu></app-bottommenu>